var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2888 5.49571C14.2888 2.46051 11.8283 0 8.79313 0C5.75794 0 3.29742 2.46051 3.29742 5.49571V9.89227C3.29742 12.9275 5.75794 15.388 8.79313 15.388C11.8283 15.388 14.2888 12.9275 14.2888 9.89227V5.49571ZM5.49571 5.49571C5.49571 3.67459 6.97201 2.19828 8.79313 2.19828C10.6142 2.19828 12.0906 3.67459 12.0906 5.49571V9.89227C12.0906 11.7134 10.6142 13.1897 8.79313 13.1897C6.97201 13.1897 5.49571 11.7134 5.49571 9.89227V5.49571ZM9.89227 21.8837C9.89227 22.4907 9.40017 22.9828 8.79313 22.9828C8.18609 22.9828 7.69399 22.4907 7.69399 21.8837V19.6174C3.35644 19.0765 0 15.3763 0 10.8923C0 10.2852 0.492102 9.79313 1.09914 9.79313C1.70618 9.79313 2.19828 10.2852 2.19828 10.8923C2.19828 14.5345 5.1509 17.4871 8.79313 17.4871C12.4354 17.4871 15.388 14.5345 15.388 10.8923C15.388 10.2852 15.8801 9.79313 16.4871 9.79313C17.0942 9.79313 17.5863 10.2852 17.5863 10.8923C17.5863 15.3763 14.2298 19.0765 9.89227 19.6174V21.8837Z",
    fill: "#929AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.1e5fdcbd2ad155e5a3b43929530101a1.svg";
export { ForwardRef as ReactComponent };